<template>
  <div />
</template>

<script setup lang="ts">
import { computed, watch } from 'vue'
import I18NextVue from 'i18next'
import { dispatchCustomEventGlobally } from 'www/utils'
import useChipsStore from 'www/vue_components/common/TheFilters/doctors/stores/useChipsStore'
import useFiltersStore from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore'
import updateDoctorListPage from 'www/vue_components/common/TheFilters/doctors/functions/updateDoctorListPage'
import { EVENTS as SNACKBAR_EVENTS } from 'www/vue_components/common/core/SnackbarNotification/constants'

const chipsStore = useChipsStore()
const filtersStore = useFiltersStore()

const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))

watch(
  () => filtersStore.filters.isClubAppointment,
  () => {
    chipsStore.updateClubSwitchChip({
      name: t('Клубная цена', options.value),
      isActive: filtersStore.filters.isClubAppointment !== undefined,
      isVisible: filtersStore.filters.isClubAppointment !== undefined,
      async onReset() {
        filtersStore.updateFilters({ isClubAppointment: undefined })

        await updateDoctorListPage()

        dispatchCustomEventGlobally(SNACKBAR_EVENTS.open, {
          upper: true,
          message: t('Фильтр сброшен', options.value),
        })
      },
    })
  },
  { immediate: true },
)
</script>
